import { render, staticRenderFns } from "./AppParams.vue?vue&type=template&id=10ee0e0b&"
import script from "./AppParams.vue?vue&type=script&lang=js&"
export * from "./AppParams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports